export default __webpack_public_path__ + "static/media/fullscreen-exit-icon.e9d460ea.svg";